<template>
  <div>
    <el-row style="margin-bottom:10px;">
      <!-- <el-button v-if="addOpportunityBusinessCheckImage"
         @click=" $form('addOpportunityBusinessCheckImage')"
         size='small'
         type="primary"
         style="float:right"
         icon='el-icon-circle-plus'
       >添加填写项约束
       </el-button> -->
    </el-row>

    <!-- <mytable
       :tableColums='tableColums_getSysKeyProjectList'
       api='getSysKeyProjectList'
       xupdateapi='updateSysKeyProject'
       :height="H-165" >
     </mytable> -->

    <myform :viewobj='{

      updateSysKeyProject: ["修改关键值", "el-icon-edit-outline"],
      $succeed$: getSysKeyProjectList
    }' @close='$form("updateSysKeyProject", "reset")'>
      <hide slot='skpId' />
      <hide slot='skpValueTwo' />
      <hide slot='obciKeyLabel' />
      <template v-slot:skpValue="{ Myformdata }">
        <el-select v-model='Myformdata.skpValue' clearable>
          <el-option v-for="item in obcKeyArray" :key="item.key" :label="item.label" :value="item.key">
          </el-option>
        </el-select>
      </template>
      <!-- <template v-slot:obciNecessary="{Myformdata}" >
          <el-radio v-model="Myformdata.obciNecessary" :label="obcKeyOne">是</el-radio>
          <el-radio v-model="Myformdata.obciNecessary" :label="obcKeyTwo">否</el-radio>
       </template> -->
    </myform>
    <el-card style="width: 95%;margin: 20px auto;position: relative;overflow:inherit;height: 90%;">
      <div
        style="position: absolute;top: -5%;font-size: 25px;background-color: white;width: 30%;text-align: center;color:#409EFF ;">
        <el-button type="text" style="margin: 0 10px;" :style="{ color: OtherTypeid == 1 ? '#409EFF' : 'black' }"
          @click="OtherTypeid = 1">晒单Key值控制</el-button>
        <el-button type="text" style="margin: 0 10px;" :style="{ color: OtherTypeid == 2 ? '#409EFF' : 'black' }"
          @click="OtherTypeid = 2">打卡Key值控制</el-button>

      </div>

      <div style="width: 97%;margin: 10px auto;overflow-y: scroll;height: 95%;" v-if="OtherTypeid == 1">
        <div style="display: flex;flex-wrap: wrap;align-items: center;" v-if="getSysKeyProjectList_data.data">
          <div style="width: 20%;margin: 10px 0;">
            楼宇是否展示:
          </div>
          <div style="width: 25%;margin: 10px 0;">
            <el-switch v-model="getSysKeyProjectList_data.data.ouBuildingHas" active-text="是" inactive-text="否"
              :active-value="2" :inactive-value="1" @change="changeKey($event, 'ouBuildingHas')">
            </el-switch>
          </div>
          <div style="width: 20%;margin: 10px 0;">
            楼宇是否必填:
          </div>
          <div style="width: 25%;margin: 10px 0;">
            <el-switch v-model="getSysKeyProjectList_data.data.ouBuildingHasMust" active-text="是" inactive-text="否"
              :active-value="2" :inactive-value="1" @change="changeKey($event, 'ouBuildingHasMust')">
            </el-switch>
          </div>
          <div style="width: 20%;margin: 10px 0;">
            楼宇分类是否展示:
          </div>
          <div style="width: 25%;margin: 10px 0;">
            <el-switch v-model="getSysKeyProjectList_data.data.ouBuildingClassHas" active-text="是" inactive-text="否"
              :active-value="2" :inactive-value="1" @change="changeKey($event, 'ouBuildingClassHas')">
            </el-switch>
          </div>
          <div style="width: 20%;margin: 10px 0;">
            楼宇分类是否必填:
          </div>
          <div style="width: 25%;margin: 10px 0;">
            <el-switch v-model="getSysKeyProjectList_data.data.ouBuildingClassHasMust" active-text="是" inactive-text="否"
              :active-value="2" :inactive-value="1" @change="changeKey($event, 'ouBuildingClassHasMust')">
            </el-switch>
          </div>
          <div style="width: 20%;margin: 10px 0;">
            物业是否展示:
          </div>
          <div style="width: 25%;margin: 10px 0;">
            <el-switch v-model="getSysKeyProjectList_data.data.ouPropertyHas" active-text="是" inactive-text="否"
              :active-value="2" :inactive-value="1" @change="changeKey($event, 'ouPropertyHas')">
            </el-switch>
          </div>
          <div style="width: 20%;margin: 10px 0;">
            物业是否必填:
          </div>
          <div style="width: 25%;margin: 10px 0;">
            <el-switch v-model="getSysKeyProjectList_data.data.ouPropertyHasMust" active-text="是" inactive-text="否"
              :active-value="2" :inactive-value="1" @change="changeKey($event, 'ouPropertyHasMust')">
            </el-switch>
          </div>
          <div style="width: 20%;margin: 10px 0;">
            业务签约是否展示:
          </div>
          <div style="width: 25%;margin: 10px 0;">
            <el-switch v-model="getSysKeyProjectList_data.data.ouTypeHas" active-text="是" inactive-text="否"
              :active-value="2" :inactive-value="1" @change="changeKey($event, 'ouTypeHas')">
            </el-switch>
          </div>
          <div style="width: 20%;margin: 10px 0;">
            业务签约是否必填:
          </div>
          <div style="width: 25%;margin: 10px 0;">
            <el-switch v-model="getSysKeyProjectList_data.data.ouTypeHasMust" active-text="是" inactive-text="否"
              :active-value="2" :inactive-value="1" @change="changeKey($event, 'ouTypeHasMust')">
            </el-switch>
          </div>
          <div style="width: 20%;margin: 10px 0;">
            合同类型是否展示:
          </div>
          <div style="width: 25%;margin: 10px 0;">
            <el-switch v-model="getSysKeyProjectList_data.data.ouContractTypeHas" active-text="是" inactive-text="否"
              :active-value="2" :inactive-value="1" @change="changeKey($event, 'ouContractTypeHas')">
            </el-switch>
          </div>
          <div style="width: 20%;margin: 10px 0;">
            合同类型是否必填:
          </div>
          <div style="width: 25%;margin: 10px 0;">
            <el-switch v-model="getSysKeyProjectList_data.data.ouContractTypeHasMust" active-text="是" inactive-text="否"
              :active-value="2" :inactive-value="1" @change="changeKey($event, 'ouContractTypeHasMust')">
            </el-switch>
          </div>
          <div style="width: 20%;margin: 10px 0;">
            业务签约场景是否展示:
          </div>
          <div style="width: 25%;margin: 10px 0;">
            <el-switch v-model="getSysKeyProjectList_data.data.ouContractSceneHas" active-text="是" inactive-text="否"
              :active-value="2" :inactive-value="1" @change="changeKey($event, 'ouContractSceneHas')">
            </el-switch>
          </div>
          <div style="width: 20%;margin: 10px 0;">
            业务签约场景是否必填:
          </div>
          <div style="width: 25%;margin: 10px 0;">
            <el-switch v-model="getSysKeyProjectList_data.data.ouContractSceneHasMust" active-text="是" inactive-text="否"
              :active-value="2" :inactive-value="1" @change="changeKey($event, 'ouContractSceneHasMust')">
            </el-switch>
          </div>
          <div style="width: 20%;margin: 10px 0;">
            业务金额是否展示:
          </div>
          <div style="width: 25%;margin: 10px 0;">
            <el-switch v-model="getSysKeyProjectList_data.data.ouMoneyHas" active-text="是" inactive-text="否"
              :active-value="2" :inactive-value="1" @change="changeKey($event, 'ouMoneyHas')">
            </el-switch>
          </div>
          <div style="width: 20%;margin: 10px 0;">
            业务金额是否必填:
          </div>
          <div style="width: 25%;margin: 10px 0;">
            <el-switch v-model="getSysKeyProjectList_data.data.ouMoneyHasMust" active-text="是" inactive-text="否"
              :active-value="2" :inactive-value="1" @change="changeKey($event, 'ouMoneyHasMust')">
            </el-switch>
          </div>
          <div style="width: 20%;margin: 10px 0;">
            年化金额是否展示:
          </div>
          <div style="width: 25%;margin: 10px 0;">
            <el-switch v-model="getSysKeyProjectList_data.data.ouMoneyYearHas" active-text="是" inactive-text="否"
              :active-value="2" :inactive-value="1" @change="changeKey($event, 'ouMoneyYearHas')">
            </el-switch>
          </div>
          <div style="width: 20%;margin: 10px 0;">
            年化金额是否必填:
          </div>
          <div style="width: 25%;margin: 10px 0;">
            <el-switch v-model="getSysKeyProjectList_data.data.ouMoneyYearHasMust" active-text="是" inactive-text="否"
              :active-value="2" :inactive-value="1" @change="changeKey($event, 'ouMoneyYearHasMust')">
            </el-switch>
          </div>
          <div style="width: 20%;margin: 10px 0;">
           订单描述是否展示:
          </div>
          <div style="width: 25%;margin: 10px 0;">
            <el-switch v-model="getSysKeyProjectList_data.data.ouRemarkHas" active-text="是" inactive-text="否"
              :active-value="2" :inactive-value="1" @change="changeKey($event, 'ouRemarkHas')">
            </el-switch>
          </div>
          <div style="width: 20%;margin: 10px 0;">
            订单描述是否必填:
          </div>
          <div style="width: 25%;margin: 10px 0;">
            <el-switch v-model="getSysKeyProjectList_data.data.ouRemarkHasMust" active-text="是" inactive-text="否"
              :active-value="2" :inactive-value="1" @change="changeKey($event, 'ouRemarkHasMust')">
            </el-switch>
          </div>
          <div style="width: 20%;margin: 10px 0;">
           集团编码是否展示:
          </div>
          <div style="width: 25%;margin: 10px 0;">
            <el-switch v-model="getSysKeyProjectList_data.data.ouGroupNumHas" active-text="是" inactive-text="否"
              :active-value="2" :inactive-value="1" @change="changeKey($event, 'ouGroupNumHas')">
            </el-switch>
          </div>
          <div style="width: 20%;margin: 10px 0;">
            集团编码是否必填:
          </div>
          <div style="width: 25%;margin: 10px 0;">
            <el-switch v-model="getSysKeyProjectList_data.data.ouGroupNumHasMust" active-text="是" inactive-text="否"
              :active-value="2" :inactive-value="1" @change="changeKey($event, 'ouGroupNumHasMust')">
            </el-switch>
          </div>
          <div style="width: 20%;margin: 10px 0;">
           当月收入是否展示:
          </div>
          <div style="width: 25%;margin: 10px 0;">
            <el-switch v-model="getSysKeyProjectList_data.data.ouMoneyMonthHas" active-text="是" inactive-text="否"
              :active-value="2" :inactive-value="1" @change="changeKey($event, 'ouMoneyMonthHas')">
            </el-switch>
          </div>
          <div style="width: 20%;margin: 10px 0;">
            当月收入是否必填:
          </div>
          <div style="width: 25%;margin: 10px 0;">
            <el-switch v-model="getSysKeyProjectList_data.data.ouMoneyMonthHasMust" active-text="是" inactive-text="否"
              :active-value="2" :inactive-value="1" @change="changeKey($event, 'ouMoneyMonthHasMust')">
            </el-switch>
          </div>
          <div style="width: 20%;margin: 10px 0;">
           贵宾号是否展示:
          </div>
          <div style="width: 25%;margin: 10px 0;">
            <el-switch v-model="getSysKeyProjectList_data.data.ouNumVipHas" active-text="是" inactive-text="否"
              :active-value="2" :inactive-value="1" @change="changeKey($event, 'ouNumVipHas')">
            </el-switch>
          </div>
          <div style="width: 20%;margin: 10px 0;">
            贵宾号是否必填:
          </div>
          <div style="width: 25%;margin: 10px 0;">
            <el-switch v-model="getSysKeyProjectList_data.data.ouNumVipHasMust" active-text="是" inactive-text="否"
              :active-value="2" :inactive-value="1" @change="changeKey($event, 'ouNumVipHasMust')">
            </el-switch>
          </div>
          <div style="width: 20%;margin: 10px 0;">
            其他业务分类是否展示:
          </div>
          <div style="width: 25%;margin: 10px 0;">
            <el-switch v-model="getSysKeyProjectList_data.data.ouBcIdOtherHas" active-text="是" inactive-text="否"
              :active-value="2" :inactive-value="1" @change="changeKey($event, 'ouBcIdOtherHas')">
            </el-switch>
          </div>
          <div style="width: 20%;margin: 10px 0;">
            
          </div>
          <div style="width: 25%;margin: 10px 0;">
         
          </div>
        </div>
      </div>
      <div style="width: 97%;margin: 10px auto;overflow-y: scroll;height: 95%;" v-if="OtherTypeid == 2">
        <div style="display: flex;flex-wrap: wrap;align-items: center;" v-if="getSysKeyProjectVisitorList_data.data">
          <div style="width: 20%;margin: 10px 0;">
            自定义打卡中的楼宇是否展示:
          </div>
          <div style="width: 25%;margin: 10px 0;">
            <el-switch v-model="getSysKeyProjectVisitorList_data.data.uvCustomizeBuildingHas" active-text="是"
              inactive-text="否" :active-value="2" :inactive-value="1"
              @change="changeKey($event, 'uvCustomizeBuildingHas')">
            </el-switch>
          </div>
          <div style="width: 20%;margin: 10px 0;">
            自定义打卡中的楼宇是否必填:
          </div>
          <div style="width: 25%;margin: 10px 0;">
            <el-switch v-model="getSysKeyProjectVisitorList_data.data.uvCustomizeBuildingHasMust" active-text="是"
              inactive-text="否" :active-value="2" :inactive-value="1"
              @change="changeKey($event, 'uvCustomizeBuildingHasMust')">
            </el-switch>
          </div>
          <div style="width: 20%;margin: 10px 0;">
            自定义打卡中的楼宇分类是否展示:
          </div>
          <div style="width: 25%;margin: 10px 0;">
            <el-switch v-model="getSysKeyProjectVisitorList_data.data.uvCustomizeBuildingClassHas" active-text="是"
              inactive-text="否" :active-value="2" :inactive-value="1"
              @change="changeKey($event, 'uvCustomizeBuildingClassHas')">
            </el-switch>
          </div>
          <div style="width: 20%;margin: 10px 0;">
            自定义打卡中的楼宇分类是否必填:
          </div>
          <div style="width: 25%;margin: 10px 0;">
            <el-switch v-model="getSysKeyProjectVisitorList_data.data.uvCustomizeBuildingClassHasMust" active-text="是"
              inactive-text="否" :active-value="2" :inactive-value="1"
              @change="changeKey($event, 'uvCustomizeBuildingClassHasMust')">
            </el-switch>
          </div>
          <div style="width: 20%;margin: 10px 0;">
            自定义打卡中的物业是否展示:
          </div>
          <div style="width: 25%;margin: 10px 0;">
            <el-switch v-model="getSysKeyProjectVisitorList_data.data.uvCustomizePropertyHas" active-text="是"
              inactive-text="否" :active-value="2" :inactive-value="1"
              @change="changeKey($event, 'uvCustomizePropertyHas')">
            </el-switch>
          </div>
          <div style="width: 20%;margin: 10px 0;">
            自定义打卡中的物业是否必填:
          </div>
          <div style="width: 25%;margin: 10px 0;">
            <el-switch v-model="getSysKeyProjectVisitorList_data.data.uvCustomizePropertyHasMust" active-text="是"
              inactive-text="否" :active-value="2" :inactive-value="1"
              @change="changeKey($event, 'uvCustomizePropertyHasMust')">
            </el-switch>
          </div>
        </div>
      </div>
    </el-card>

  </div>
</template>
  
<script>
export default {
  data() {
    return {
      OtherTypeid: 1,
      theProjectId: "",
      obcKeyOne: 1,
      obcKeyTwo: 2,
      obcKeyArray: [
        { key: 1, label: "1" },
        { key: 2, label: "2" },


      ],

      tableColums_getSysKeyProjectList: {
        $selection: false,

        // oiType: '限制字段key',

        skpDes: '限制字段名称',

        skpValue: ['是否展示', , '@v-if: 1:否, 2:是 '],

        $operation: [
          '操作', 200,
          this.updateSysKeyProject && `@text: 编辑#success
                 @click: $form("updateSysKeyProject",$row)
                `,

        ],

      },
    }
  },

  methods: {
    changeKey(e, key) {
      console.log(e, key);

      if (this.OtherTypeid == 1) {
        const formData = new FormData();
        formData.append(key, e);
        formData.append('skpId', this.getSysKeyProjectList_data.data.skpId);
        this.updateSysKeyProject(formData)
      }else{
        const formData = new FormData();
        formData.append(key, e);
        formData.append('skpvId', this.getSysKeyProjectVisitorList_data.data.skpvId);
        this.updateSysKeyProjectVisitor(formData)
      }
    },
    myform(submit, Myformdata) {
      Myformdata.projectId = this.theProjectId;
      var oiType = Myformdata.oiType;
      this.obcKeyArray.forEach(element => {
        if (element.key == oiType) {
          Myformdata.obciKeyLabel = element.label;
        }
      });
      submit();
    },
  },
  created() {
    this.theProjectId = A.local('$projectId');
    this.getSysKeyProjectList({ projectId: this.theProjectId });
    this.getSysKeyProjectVisitorList({ projectId: this.theProjectId });
  }
}
</script>
  
<style scoped="scoped">
div .el-button {
  font-size: 18px;
}</style>
  


// WEBPACK FOOTER //
// src/views/bussiness/projectKey.vue